import {
  SelectOption,
  TestRequestProcessComplexity,
  TestRequestProcessSolutionType,
  TestRequestProcessSupportType,
  TestRequestProcessTapeInUse,
} from "./models";

export const COMPLEXITY_OPTIONS: SelectOption<TestRequestProcessComplexity>[] = [
  { name: "S", value: "SMALL" },
  { name: "M", value: "MEDIUM" },
  { name: "L", value: "LARGE" },
];
export const TAPE_USED_OPTIONS: SelectOption<TestRequestProcessTapeInUse>[] = [
  {
    name: "Existing Product",
    value: "EXISTING",
  },
  { name: "New Product Development", value: "NEW" },
];
export const SUPPORT_TYPE_OPTIONS: SelectOption<TestRequestProcessSupportType>[] = [
  {
    name: "Use Existing Solution",
    value: "USE_EXISTING",
  },
  { name: "Modify Existing Solution", value: "MODIFY_EXISTING" },
  { name: "New Development", value: "NEW_DEVELOPMENT" },
];
export const SOLUTION_TYPE_OPTIONS: SelectOption<TestRequestProcessSolutionType>[] = [
  {
    name: "Hand Applicator",
    value: "HAND_APPLICATOR",
  },
  { name: "Table Dispenser", value: "TABLE_DISPENSER" },
  { name: "Automation own Development", value: "AUTOMATION_OWN_DEVELOPMENT" },
  { name: "Automation 3rd Party", value: "AUTOMATION_THIRD_PARTY" },
  { name: "Other", value: "OTHER" },
];
